import { makeStyles } from '@material-ui/core/styles';

export const useFormContainerStyles = makeStyles(theme => ({
    formContainer: {
      paddingTop: theme.spacing(2),
      paddingBottom: `${theme.spacing(2)}px !important`,
      background: 'white',
      padding: theme.spacing(3),
      borderRadius: '4px',
      marginTop: theme.spacing(4),
      flexGrow: 1,
      '&.grow-0':{
        flexGrow: 0
      },
      '& .MuiGrid-item':{
        // paddingTop: 0,
        // paddingBottom: 0
      },
    }
}));
